import React, { useCallback, useContext, useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import { getPublicUser } from '@sbt-web/auth';
import ErrorBoundary from '@sbt-web/error-boundary';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { COUNT_STORAGE_KEY } from './shared';
import { PremiumSavedSearchModal } from './modal';

export const EXPERIMENT_ALIAS = 'subito-web-premium-saved-searches';
const MAX_DISPLAY_COUNT = 10;

const PremiumSavedSearchExperiment = () => {
  const { optimizely } = useContext(OptimizelySubitoContext);
  const [openDialog, setOpenDialog] = useState(false);

  const handleExperiment = useCallback(() => {
    const user = getPublicUser();
    const displayCount = Number.parseInt(
      localStorage.getItem(COUNT_STORAGE_KEY) ?? '0'
    );

    if (!user) {
      Sentry.captureException('[PremiumSavedSearch] Missing user');
      return;
    }

    if (displayCount >= MAX_DISPLAY_COUNT) {
      return;
    }

    optimizely?.onReady().then(() => {
      if (optimizely?.activate(EXPERIMENT_ALIAS, user?.id) === 'B') {
        setOpenDialog(true);
      }
    });
  }, [optimizely]);

  useEffect(() => {
    const controller = new AbortController();
    window.addEventListener('subito:saveSearch:saved', handleExperiment, {
      signal: controller.signal,
    });

    return () => controller.abort();
  }, [handleExperiment]);

  return (
    <PremiumSavedSearchModal
      open={openDialog}
      onClose={() => setOpenDialog(false)}
    />
  );
};

const WrappedComponent = () => (
  <ErrorBoundary>
    <PremiumSavedSearchExperiment />
  </ErrorBoundary>
);

export default WrappedComponent;
